import * as R from 'ramda'
import {update} from './ObjectHelper'

export interface ClientSidePagination<T> {
    readonly items: T[]
    readonly currentPage: number
    readonly totalRemoteCount: number
}

export function slice<T>(
    itemsPerPage: number,
    {items, currentPage}: ClientSidePagination<T>,
): T[] {
    return R.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage,
        items,
    )
}

export function numberOfPages<T>(
    itemsPerPage: number,
    {items}: ClientSidePagination<T>,
): number {
    return Math.max(1, Math.ceil(items.length / itemsPerPage))
}

export function next<T>(
    itemsPagePage: number,
    pagination: ClientSidePagination<T>,
): ClientSidePagination<T> {
    return update(
        {
            currentPage:
                Math.min(
                    numberOfPages(itemsPagePage, pagination),
                    pagination.currentPage + 1,
                ),
        },
        pagination,
    )
}

export function previous<T>(
    pagination: ClientSidePagination<T>,
): ClientSidePagination<T> {
    return update(
        {currentPage: Math.max(1, pagination.currentPage - 1)},
        pagination,
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/ClientSidePagination.ts